import React, { useEffect, useState } from 'react';
import { CheckCircleOutlined, CloseOutlined, FilePdfOutlined } from '@ant-design/icons';
import { fileDownload } from '@utils';
import { notification, Progress } from 'antd';
import {
    StyledCloseButton,
    StyledDescription,
    StyledIconWrapper,
    StyledModal,
    StyledModalContent,
    StyledProgressWrapper,
    StyledTitle
} from './styled';

const DownloadModal = ({ params, setIsModalOpen, type = 'Statements', downloadPDFInvoices }) => {
    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState('loading');

    const typeLabelMap = {
        Charges: 'Invoice',
        Payouts: 'Payout',
        Statements: 'Statement'
    };

    const label = typeLabelMap[type] || type;

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 90) return prev;
                return prev + Math.random() * 15;
            });
        }, 500);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const checkPDF = async () => {
            try {
                const url = await downloadPDFInvoices({
                    ...params,
                    transaction_type: type.toLowerCase(),
                    polling: true
                });

                if (url) {
                    setStatus('success');

                    fileDownload(url);

                    setTimeout(() => setIsModalOpen(false), 2000);
                    return true;
                }

                return false;
            } catch (error) {
                notification.error({
                    message: 'Something went wrong'
                });
                return false;
            }
        };

        const pollPDF = async () => {
            const isReady = await checkPDF();
            if (isReady) return;

            const intervalId = setInterval(async () => {
                const ready = await checkPDF();
                if (ready) clearInterval(intervalId);
            }, 5000);

            setTimeout(() => {
                clearInterval(intervalId);
                setIsModalOpen(false);
            }, 120000);

            return () => clearInterval(intervalId);
        };

        pollPDF();
    }, []);

    if (status === 'success') {
        return (
            <StyledModal
                width='600px'
                onCancel={() => setIsModalOpen(false)}
                open
                footer={null}
                maskClosable={false}
                destroyOnClose
                closeIcon={
                    <StyledCloseButton className='ant-modal-close-x'>
                        <CloseOutlined />
                    </StyledCloseButton>
                }
            >
                <StyledModalContent>
                    <StyledIconWrapper success>
                        <CheckCircleOutlined />
                    </StyledIconWrapper>

                    <StyledTitle data-e2e='download-pdf-modal_success_title'>
                        {label} Generated Successfully!
                    </StyledTitle>
                    <StyledDescription data-e2e='download-pdf-modal_success_description'>
                        Your PDF file has been created and downloaded.
                    </StyledDescription>
                </StyledModalContent>
            </StyledModal>
        );
    }

    return (
        <StyledModal
            width='600px'
            onCancel={() => setIsModalOpen(false)}
            open
            footer={null}
            maskClosable={false}
            destroyOnClose
            closeIcon={
                <StyledCloseButton>
                    <CloseOutlined />
                </StyledCloseButton>
            }
        >
            <StyledModalContent data-e2e='download-pdf-modal_content'>
                <StyledIconWrapper>
                    <FilePdfOutlined />
                </StyledIconWrapper>

                <StyledTitle data-e2e='download-pdf-modal_in-progress_title'>Generating Your {label}</StyledTitle>
                <StyledDescription data-e2e='download-pdf-modal_in-progress_description'>
                    Preparing your financial document...
                </StyledDescription>

                <StyledProgressWrapper>
                    <Progress
                        percent={Math.floor(progress)}
                        status='active'
                        strokeColor={{
                            '0%': 'rgb(218, 23, 129)',
                            '100%': 'rgb(218, 23, 129)'
                        }}
                    />
                </StyledProgressWrapper>
            </StyledModalContent>
        </StyledModal>
    );
};

export default DownloadModal;
